import { ReactElement, useState, useEffect } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

import { useCheckoutState } from '~/hooks/checkout';
import { CheckoutStepProps } from '~/types/checkout';
import { STEP } from '~/constants/checkout';

function ErrorMessage({
  errorMessage,
}: Readonly<{ errorMessage?: string | void }>): ReactElement {
  if (!errorMessage) return <></>;

  return (
    <div className="mt-2 text-brick">
      <FontAwesomeIcon
        icon={faCircleExclamation}
        height="16"
        className="mr-2"
      />
      <span className="text-sm">{errorMessage}</span>
    </div>
  );
}

export function CheckoutCard({
  children,
  step,
}: Readonly<{
  children: React.ReactNode;
  step: CheckoutStepProps;
}>): ReactElement {
  const { step: activeStep, stepErrorMessageObject } = useCheckoutState();
  const [errorMessage, setErrorMessage] = useState<string | void>(undefined);

  useEffect(() => {
    const error = stepErrorMessageObject[step];

    if (error !== errorMessage) {
      setErrorMessage(error);
    }
  }, [stepErrorMessageObject, errorMessage, step]);

  const errorStyle = {
    borderColor: '#C22F0F',
    outlineColor: '#C22F00',
  };

  // Dynamically added classes not always working
  return (
    <div>
      <div
        className={`flex w-full flex-col items-start rounded border border-sundog p-4 outline outline-1 outline-transparent md:p-6 ${clsx(
          {
            'pb-0 md:pb-0':
              step === STEP.PAYMENT && activeStep === STEP.PAYMENT,
          },
        )}`}
        style={errorMessage ? errorStyle : {}}
      >
        {children}
      </div>
      <ErrorMessage errorMessage={errorMessage} />
    </div>
  );
}
